import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  FrameContainer,
  Label,
  LabelText,
  CardView,
  CardContainer,
} from "./HomeGamification.styled";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import { ReactComponent as VectorIcon } from "../../assets/svg/vector-icon.svg";
import { MY_GAMES } from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import { clientWellness } from "../../App";
import { Link } from "react-router-dom";
import ListCardMyGamesHome from "../../components/ListCardMyGamesHome/ListCardMyGamesHome";

const HomeGamification = () => {
  const history = useHistory();
  const [myGames, setMyGames] = useState([]);
  const [initialDate] = useState(new Date());
  const [endDate] = useState(() => {
    let futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 10000);
    return futureDate;
  });
  const [runQueryMyGames, { loading: loadingMyGames, error: errorMyGames }] =
    useLazyQuery(MY_GAMES, {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let mygamesActiveList = data?.myGames?.nodes.filter(
          (game) => game.status !== "Inactive"
        );
        console.log(mygamesActiveList);
        setMyGames(mygamesActiveList.slice(0, 4));
      },
    });

  useEffect(() => {
    runQueryMyGames({
      variables: {
        initialDate: new Date(initialDate),
        finalDate: new Date(endDate),
        searchBy: "",
      },
    });
  }, []);

  let goToDetail = (myspace) => {
    setTimeout(() => {
      history.push({ pathname: "/DetailGame", state: { url: myspace.url } });
    }, 0);
  };

  return (
    <>
      {myGames && myGames.length > 0 ? (
        <FrameContainer>
          <Label>
            <LabelText>
              <Link to="/MyGames">
                Gamification
                <ArrowForward />
              </Link>
            </LabelText>
          </Label>
          <CardContainer>
            {myGames.map((data, index) => (
              <CardView key={index}>
                <ListCardMyGamesHome
                  loadingMyGames={loadingMyGames}
                  errorMyGames={errorMyGames}
                  goToDetail={goToDetail}
                  myGame={data}
                />
              </CardView>
            ))}
          </CardContainer>
        </FrameContainer>
      ) : (
        <FrameContainer>
          <Label>
            <LabelText>
              <Link to="/MyGames">
                Gamification
                <ArrowForward />
              </Link>
            </LabelText>
          </Label>
          <CardContainer>
            <VectorIcon style={{ marginRight: "23px" }} />
            <VectorIcon style={{ marginRight: "23px" }} />
            <VectorIcon style={{ marginRight: "23px" }} />
            <VectorIcon />
          </CardContainer>
        </FrameContainer>
      )}
    </>
  );
};
export default HomeGamification;
